import React from 'react';
import styles from './index.module.scss';
import { SmartLiraAdvContainer } from '@client/components/Search/Containers/SmartAdvItem';
import { LiraContainerIds } from '@client/components/Adv/Lira/liraContainerIds';

export const AdsBeforeListingBlock = () => (
  <div className={styles['adsense-before-listing-container']}>
    <SmartLiraAdvContainer id={LiraContainerIds.listing.aboveListing} />
  </div>
);
